import { useMsal } from "@azure/msal-react";

export const useLogout = () => {
  const { instance } = useMsal();

  const logout = () => {
    try {
        instance.logoutRedirect();
      } catch (error) {
        console.error(error);
      }
  };

  return { logout };
};
